import React from 'react'
import { IconButton } from '@mui/material'
import FilterListIcon from '@mui/icons-material/FilterList'

import ProcedureFiltersModal from './ProcedureFiltersModal'
import { TProcedureFiltersProps } from './ProcedureFilters.types'
import { useProcedureFiltersLogic } from './useProcedureFiltersLogic'

const ProcedureFilters: React.FC<TProcedureFiltersProps> = ({
  filters,
  surgeries,
  onApplyFilters,
  onClearFilters,
  isAnyFilterActive,
}) => {
  const { isOpen, handleOpen, handleClose } = useProcedureFiltersLogic()

  return (
    <>
      <IconButton
        onClick={handleOpen}
        size="large"
        color={isAnyFilterActive ? 'primary' : 'default'}
        sx={{
          borderColor: 'primary.main',
          border: isAnyFilterActive ? '1px solid' : 'none',
          backgroundColor: isAnyFilterActive ? 'primary.light' : 'transparent',
        }}
      >
        <FilterListIcon fontSize="medium" />
      </IconButton>

      <ProcedureFiltersModal
        open={isOpen}
        filters={filters}
        onClose={handleClose}
        surgeries={surgeries}
        onApplyFilters={onApplyFilters}
        onClearFilters={onClearFilters}
      />
    </>
  )
}

export default ProcedureFilters
